import type { ApolloCache } from '@apollo/client';
import { gql } from '@apollo/client';
import type { GetAdminRegistryRegistriesQuery } from '../../apps/registry/admin/Registry.graphql.generated';
import type { CreateRegistryItemFromCatalogItemMutation } from '@graphql/mutations/catalog.graphql.generated';
import { GetAdminRegistryRegistriesDocument } from '../../apps/registry/admin/Registry.graphql.generated';
import { merge } from 'lodash-es';

export const CREATE_REGISTRY__ITEM_FROM_CATALOG_ITEM = gql`
  mutation CreateRegistryItemFromCatalogItem($eventId: ID!, $payload: CreateRegistryItemFromCatalogItemPayload!) {
    createRegistryItemFromCatalogItem(eventId: $eventId, payload: $payload) {
      model {
        ...RegistryItem
      }
      status {
        id
      }
    }
  }
`;

type UpdateRegistriesCacheAfterCreateItemProps = {
  cache: ApolloCache<{}>;
  result: Maybe<CreateRegistryItemFromCatalogItemMutation>;
  eventHandle: Maybe<string>;
};

export const updateRegistriesCacheAfterCreateItem = ({ cache, result, eventHandle }: UpdateRegistriesCacheAfterCreateItemProps) => {
  const getRegistriesQueryProps = {
    query: GetAdminRegistryRegistriesDocument,
    variables: { eventHandle },
  };

  const getRegistriesCache = cache.readQuery<GetAdminRegistryRegistriesQuery>(getRegistriesQueryProps);
  const cachedRegistries = getRegistriesCache?.eventByName?.info.registry;
  const standaloneRegistryIndex = cachedRegistries?.findIndex(registry => registry.type === 'standalone') ?? -1;
  const newRegistryItem = result?.createRegistryItemFromCatalogItem.model;
  if (!cachedRegistries || !newRegistryItem || standaloneRegistryIndex === -1) {
    return;
  }
  const cachedStandaloneRegistry = cachedRegistries[standaloneRegistryIndex];
  const newStandaloneRegistry = { ...cachedStandaloneRegistry, items: [...(cachedStandaloneRegistry.items ?? []), newRegistryItem] };
  const newRegistries = [...cachedRegistries];
  newRegistries[standaloneRegistryIndex] = newStandaloneRegistry;
  const getRegistriesUpdate: DeepPartial<GetAdminRegistryRegistriesQuery> = { eventByName: { info: { registry: newRegistries } } };
  cache.writeQuery<GetAdminRegistryRegistriesQuery>(merge({}, getRegistriesQueryProps, { data: getRegistriesCache }, { data: getRegistriesUpdate }));
};
